module.exports = __webpack_public_path__ + "img/login-logo.19f18c13.png";